import { Box, Button, Typography } from "@mui/material";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import { useTranslation } from "react-i18next";
import ScreeningParticipantLayout from "./ScreeningParticipantLayout";

type Props = {
  onRetry: () => void;
};

const ScreeningLoadError = ({ onRetry }: Props) => {
  const { t } = useTranslation("participant-flow");

  return (
    <ScreeningParticipantLayout>
      <ErrorOutlineRoundedIcon sx={{ fontSize: 64, color: "error.main", mb: 2 }} />
      <Typography
        variant="h5"
        fontWeight="medium"
        color="text.primary"
        textAlign="center"
      >
        {t("SCREENING_LOAD_ERROR_TITLE")}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        textAlign="center"
        sx={{ mt: 1, maxWidth: 420 }}
      >
        {t("SCREENING_LOAD_ERROR_BODY")}
      </Typography>
      <Box sx={{ mt: 3 }}>
        <Button variant="contained" onClick={onRetry}>
          {t("SCREENING_LOAD_ERROR_RETRY")}
        </Button>
      </Box>
    </ScreeningParticipantLayout>
  );
};

export default ScreeningLoadError;
